export default function GameConsole(props: any) {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M10.3075 15.5772C10.6001 14.6398 11.4634 14 12.429 14H24.3678H37.3893C38.3988 14 39.2767 14.6844 39.54 15.6665L43.8269 31.7359C44.6608 34.8456 42.3784 37.9107 39.2035 37.9554C37.2869 37.9851 35.5312 36.8394 34.7265 35.0539L32.7384 30.5924C32.3547 29.7314 31.5003 29.1767 30.5576 29.1767H18.0675C17.0993 29.1767 16.2269 29.7614 15.8591 30.657L14.053 35.0539C13.3215 36.8394 11.6097 38 9.70766 38C6.51813 38 4.25034 34.8456 5.23061 31.7656L10.3075 15.5772Z"
                stroke="white"
                strokeWidth="2.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M30.6406 24C32.0213 24 33.1406 22.8807 33.1406 21.5C33.1406 20.1193 32.0213 19 30.6406 19C29.2599 19 28.1406 20.1193 28.1406 21.5C28.1406 22.8807 29.2599 24 30.6406 24Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M18.6406 24C20.0213 24 21.1406 22.8807 21.1406 21.5C21.1406 20.1193 20.0213 19 18.6406 19C17.2599 19 16.1406 20.1193 16.1406 21.5C16.1406 22.8807 17.2599 24 18.6406 24Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
